import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { useSearch } from "hooks/useSearch";
import { setReportComoDataFilters, getReportComoDataAction } from "redux/actions/Reports/reportComoData/reportComoDataActions";

export const ReportComoDataView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(({ reportComoData }) => reportComoData);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    dispatch(getReportComoDataAction({year: date, station, isPdf}))
  }, [date, station]);

  return (
    <GlobalBox title="Reporte de ComoDatos" icon={<AssessmentIcon />} >
      <TableInputs
        reducer="reportComoData"
        date
        yearType
        stations
        dispatchAction={setReportComoDataFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingReportComoData}
      />
      {isLoadingComp?.loadingReportComoData && <LoadingComponent />}
    </GlobalBox>
  );
};
